/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Forgot_Password_TitleInputs */

const en_common_sign_forgot_password_title = /** @type {(inputs: Common_Sign_Forgot_Password_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forgot password`)
};

const zh_common_sign_forgot_password_title = /** @type {(inputs: Common_Sign_Forgot_Password_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`找回密码`)
};

/**
* | output |
* | --- |
* | "Forgot password" |
*
* @param {Common_Sign_Forgot_Password_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_forgot_password_title = /** @type {((inputs?: Common_Sign_Forgot_Password_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Forgot_Password_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_forgot_password_title(inputs)
	return zh_common_sign_forgot_password_title(inputs)
});
export { common_sign_forgot_password_title as "common.sign.forgot_password_title" }